<script lang="ts">
  let {
    appStoreUrl = null,
    playStoreUrl = null,
    appleAppId = null,
    currentUrl,
  }: {
    appStoreUrl?: string | null;
    playStoreUrl?: string | null;
    appleAppId?: string | null;
    currentUrl: string;
  } = $props();
</script>

<svelte:head>
  {#if appleAppId}
    <meta name="apple-itunes-app" content={`app-id=${appleAppId}, app-argument=${currentUrl}`} />
  {/if}
</svelte:head>

<div
  class="min-h-screen bg-app flex items-center justify-center p-4"
  style="word-break: keep-all; overflow-wrap: break-word;"
>
  <div class="w-full max-w-sm">
    <div class="card text-center">
      <img
        src="/icon.png"
        alt="TripHelper"
        class="w-20 h-20 mx-auto rounded-2xl shadow-md"
      />

      <h1 class="text-2xl font-bold text-primary mt-6">
        친구와 함께<br />
        계획하고 기록하는 여행
      </h1>
      <p class="text-sm text-secondary mt-3">
        TripHelper 앱에서 계속 이용해보세요
      </p>

      <div class="mt-8 space-y-3">
        <a href="triphelper://home" class="btn btn-primary w-full">
          앱에서 열기
        </a>

        <div class="flex gap-3">
          {#if appStoreUrl}
            <a
              href={appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-secondary flex-1 gap-2"
              aria-label="App Store에서 TripHelper 받기"
            >
              <svg viewBox="0 0 384 512" width="18" height="18" fill="currentColor" aria-hidden="true">
                <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
              </svg>
              <span>App Store</span>
            </a>
          {:else}
            <span
              class="btn btn-secondary flex-1 gap-2 opacity-40 cursor-not-allowed"
              aria-disabled="true"
            >
              <svg viewBox="0 0 384 512" width="18" height="18" fill="currentColor" aria-hidden="true">
                <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
              </svg>
              <span>출시 준비 중</span>
            </span>
          {/if}

          {#if playStoreUrl}
            <a
              href={playStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-secondary flex-1 gap-2"
              aria-label="Google Play에서 TripHelper 받기"
            >
              <svg viewBox="0 0 512 512" width="18" height="18" aria-hidden="true">
                <path fill="#3DDC84" d="M48 59.49v393a4.33 4.33 0 0 0 7.37 3.07L260 256 55.37 56.42A4.33 4.33 0 0 0 48 59.49z"/>
                <path fill="#3DDC84" d="M345.8 174L89.22 25.54l-.16-.09c-4.42-2.55-8.66 3.43-5 7l201.13 200.32z"/>
                <path fill="#3DDC84" d="M84.08 479.54l.16-.09L345.8 338l-65.61-65.62L84.08 472.46c-3.64 3.64.6 9.61 5 7.08z"/>
                <path fill="#3DDC84" d="M449.38 231.81l-71.65-39.46-72.43 72.43 72.44 72.44 71.64-39.46c19.49-10.77 19.49-38.71 0-49.49z"/>
              </svg>
              <span>Google Play</span>
            </a>
          {:else}
            <span
              class="btn btn-secondary flex-1 gap-2 opacity-40 cursor-not-allowed"
              aria-disabled="true"
            >
              <svg viewBox="0 0 512 512" width="18" height="18" aria-hidden="true">
                <path fill="#3DDC84" d="M48 59.49v393a4.33 4.33 0 0 0 7.37 3.07L260 256 55.37 56.42A4.33 4.33 0 0 0 48 59.49z"/>
                <path fill="#3DDC84" d="M345.8 174L89.22 25.54l-.16-.09c-4.42-2.55-8.66 3.43-5 7l201.13 200.32z"/>
                <path fill="#3DDC84" d="M84.08 479.54l.16-.09L345.8 338l-65.61-65.62L84.08 472.46c-3.64 3.64.6 9.61 5 7.08z"/>
                <path fill="#3DDC84" d="M449.38 231.81l-71.65-39.46-72.43 72.43 72.44 72.44 71.64-39.46c19.49-10.77 19.49-38.71 0-49.49z"/>
              </svg>
              <span>출시 준비 중</span>
            </span>
          {/if}
        </div>
      </div>

      <a
        href="/login"
        class="block mt-6 text-sm text-muted hover:text-secondary transition-colors duration-200"
      >
        웹에서 로그인
      </a>
    </div>
  </div>
</div>
